<script setup lang="ts">
import { ref  } from 'vue';
const props = defineProps({  
  size: {type:Number, default:null},
  float: {type:Boolean, default:false},
  position: {type:String, default:'right'},
  collapsible: {type:Boolean, default:false},
  expand: {type:Boolean, default:true},
})
const _width = ref(props.size)
const _expand = ref(props.expand)
const onSwitch = ()=>{
  _expand.value  = !_expand.value
}
</script>
<template>
<div
  class="splitter-panel-block"
  :class="{
    'float':props.float,
    'flex-full':!props.size,
    'position-right':props.position=='right',
    'position-left':props.position=='left'
  }" >
  <div 
    class="splitter-panel" 
    :class="{ float:props.float, collapse:!_expand, 'flex-full':!props.size}" 
    :style="{ width: _width?`${_width}px`:'auto'}">
    <slot></slot>
  </div>
  <div 
    v-if="props.collapsible" 
    class="collapsible" 
    :class="{
      'float':props.float,
      'position-right':props.position=='right',
      'position-left':props.position=='left'
    }">
    <!-- <div class="collapsible-line"></div> -->
    <div @click="onSwitch" class="collapsible-btn">
      <template v-if="props.position=='right'">
        <i v-if="_expand" class="iconfont">&#xe840;</i>
        <i v-else class="iconfont">&#xe83e;</i>
      </template>
      <template v-if="props.position=='left'">
        <i v-if="_expand" class="iconfont">&#xe83e;</i>
        <i v-else class="iconfont">&#xe840;</i>
      </template>
    </div>
  </div>  
</div>
</template>

<style lang="scss" scoped>
.splitter-panel-block{
  height: 100%;
  display: flex;
  background-color: var(--c-breadcrumb-bg);
  overflow: visible;
  &.float{
    position: fixed;
    top:0px;
    z-index: 9999;
    backdrop-filter: blur(12px);
    background: linear-gradient(180deg, var(--bg-menu-general-secondary_1, rgba(250, 250, 250, 0.80)) 0%, var(--bg-menu-general-secondary_2, rgba(250, 250, 250, 0.80)) 100%);
  }
  &.flex-full{
    flex: 1;
  }
  &.float.position-right{
    right: 0px;
    flex-direction: row-reverse;
  }
  &.float.position-left{
    left: 0px;
  }
}
.collapsible{
  height: 100%;
  position: relative;
  .collapsible-btn{
    position: absolute;
    z-index: 999;
    right: -16px;
    bottom: 0px;
    cursor: pointer;
    padding: 6px 0;

    border-radius: 0 8px 8px 0;
    box-shadow: var(--shadow-offset-meduim, 2px) var(--shadow-offset-none, 0) var(--shadow-blur-medium, 8px) var(--shadow-offset-none, 0) var(--bg-shadow-00_neutral_primary-normal, rgba(50, 50, 51, 0.20));
    border-top: 1px solid var(--bdr-divider-general-secondary, #C8C8C8);
    border-right: 1px solid var(--bdr-divider-general-secondary, #C8C8C8);
    border-bottom: 1px solid var(--bdr-divider-general-secondary, #C8C8C8);
    background: var(--bg-subtler-00_neutral_secondary-normal, #EDEDED);    
    .iconfont{
      font-size: 16px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;      
    }
  }
  &.float .collapsible-btn{
    bottom: 0px;
    transform: scaleX(-1);
  }
  &.float.position-right .collapsible-btn{
    left: -16px;
    right: 0;
  }
  &.float.position-left .collapsible-btn{
    right: -16px;
  }
}
.splitter-panel{
  position: relative;
  height: 100%;
  &.flex-full{
    flex: 1;
  }
  &.collapse{
    width: 0px !important;
  }
}
</style>